import { useState } from 'react';
import { IonItem, IonLabel, IonList, IonToggle } from '@ionic/react';
import StepLayout from './StepLayout';
import { composeManualAddress } from './AddressPicker';
import { saveDetailUserInfo } from '../../../firebaseConfig';
import { userFormStore, addressFormStore, toggleStore, appStore } from '../../../store/Store';

const SAVE_ERROR =
    "We couldn't save your details. Please try again, or contact the Parry Sound Fire Department at 705-746-2262.";

const Profile5 = () => {
    const addressForm = addressFormStore.useState((s) => s.addressForm);
    const userId = appStore.useState((s) => s.userId);
    const detailUserForm = userFormStore.useState((s) => s.detailUserForm);
    const manualAddress = toggleStore.useState((s) => s.manualAddress);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const setSubscription = (field, checked) => {
        userFormStore.update((s) => {
            s.detailUserForm = { ...s.detailUserForm, [field]: checked };
        });
    };

    const saveUserInfo = async () => {
        const address = manualAddress ? composeManualAddress(addressForm) : detailUserForm.address;
        setError('');
        setSaving(true);
        try {
            // On success this navigates to /profile.
            await saveDetailUserInfo(detailUserForm, address, userId);
        } catch (err) {
            setSaving(false);
            setError(SAVE_ERROR);
        }
    };

    return (
        <StepLayout
            title='Subscribe to important alerts?'
            primaryLabel={saving ? 'Saving…' : 'Save'}
            onPrimary={saveUserInfo}
            primaryDisabled={saving}
        >
            <p>
                The Fire Department may issue alerts for changes to Fire Risk level, Burn Bans, or
                Emergencies including train derailments. You can subscribe to receive these alerts
                below. Your email and phone number will not be used for promotional or marketing
                purposes or shared with third parties.
            </p>
            <h3 className='flow-step__section-title'>Fire Risk Alerts</h3>
            <IonList lines='full'>
                <IonItem>
                    <IonLabel className='ion-text-wrap'>SMS (Text Messages)</IonLabel>
                    <IonToggle
                        slot='end'
                        color='tertiary'
                        checked={detailUserForm.smsSub}
                        onIonChange={(e) => setSubscription('smsSub', e.detail.checked)}
                    />
                </IonItem>
                <IonItem>
                    <IonLabel className='ion-text-wrap'>Emails</IonLabel>
                    <IonToggle
                        slot='end'
                        color='tertiary'
                        checked={detailUserForm.emailSub}
                        onIonChange={(e) => setSubscription('emailSub', e.detail.checked)}
                    />
                </IonItem>
            </IonList>
            <h3 className='flow-step__section-title'>Emergency Alerts</h3>
            <IonList lines='full'>
                <IonItem>
                    <IonLabel className='ion-text-wrap'>Emergency Broadcasts</IonLabel>
                    <IonToggle
                        slot='end'
                        color='tertiary'
                        checked={detailUserForm.emergencySub}
                        onIonChange={(e) => setSubscription('emergencySub', e.detail.checked)}
                    />
                </IonItem>
            </IonList>
            {error && (
                <p className='flow-step__error' role='alert'>
                    {error}
                </p>
            )}
        </StepLayout>
    );
};

export default Profile5;
